import { MediaFormat } from 'backend/services/types/urApiService.enums'
import { MmsNielsenTrackingData } from './MMSNielsen'

export enum NielsenAutostartFlag {
  YES = 'yes',
  NO = 'no',
}

export enum NielsenPremiumContentFlag {
  YES = 'yes',
  NO = 'no',
}

class NielsenDataRetriever {
  public APP_ID = process.env.NEXT_PUBLIC_NIELSEN_ID

  public MEDIA_PLAYER = 'JW Player'

  public PREMIUM_CONTENT_FLAG = NielsenPremiumContentFlag.NO

  constructor(
    private readonly jwPlayer: JWPlayerStatic & jwplayer.JWPlayer,
    private readonly currentProduct: MmsNielsenTrackingData,
  ) {}

  getJwPlayerVersion = () => {
    return this.jwPlayer.version.split('+')[0]
  }

  getDuration = () => {
    return this.currentProduct.duration
  }

  getPosition = () => {
    return Math.round(this.jwPlayer.getPosition())
  }

  getEpisodeId = () => {
    return this.currentProduct.format === MediaFormat.AUDIO
      ? `${this.currentProduct.id}_audio`
      : this.currentProduct.id
  }

  getProgramTitle = () => {
    return this.currentProduct.seriesTitle || ''
  }

  getEpisodeTitle = () => {
    return this.currentProduct.title
  }

  getAutostartedFlag = () => {
    return this.jwPlayer.getConfig().autostart
      ? NielsenAutostartFlag.YES
      : NielsenAutostartFlag.NO
  }
}

export default NielsenDataRetriever
